{{#if h1}}
  {{#each h1}}
    <h1 {{#if animation}}data-anijs="{{animation}}"{{/if}}>{{t this}}</h1>
  {{/each}}
{{/if}}
{{#if h2}}
  {{#each h2}}
    <h2 {{#if animation}}data-anijs="{{animation}}"{{/if}}>{{t this}}</h2>
  {{/each}}
{{/if}}
{{#if h3}}
  {{#each h3}}
    <h3 {{#if animation}}data-anijs="{{animation}}"{{/if}}>{{t this}}</h3>
  {{/each}}
{{/if}}
{{#if h4}}
  {{#each h4}}
    <h4 {{#if animation}}data-anijs="{{animation}}"{{/if}}>{{t this}}</h4>
  {{/each}}
{{/if}}
{{#if h5}}
  {{#each h5}}
    <h5 {{#if animation}}data-anijs="{{animation}}"{{/if}}>{{t this}}</h5>
  {{/each}}
{{/if}}
{{#if h6}}
  {{#each h6}}
    <h6 {{#if animation}}data-anijs="{{animation}}"{{/if}}>{{t this}}</h6>
  {{/each}}
{{/if}}
